import React from 'react'
import { useField } from 'formik'
import { modeTypes } from '../constants'
import { getFieldValidationErrorMessageDOM, ReadOnlyField, SuggestWithAi } from '../helper';
import Pills from '../../Pills/Pill';

const Tag = ({ field, fieldWidth, mode }) => {
  const { formFieldUid } = field;
  const boundaryRef = React.useRef<HTMLDivElement>(null)

  const isReadOnly = mode === modeTypes.readOnly || field.readOnly

  const [tagsField, tagsMeta] = useField(formFieldUid);

  const handleChange = (data) => {
    if (field.isUnique) {
      const textCount = data.reduce((acc, item) => {
        acc[item.text] = (acc[item.text] || 0) + 1;
        return acc;
      }, {});

      const updated = data.map(item => ({
        ...item,
        isError: textCount[item.text] > 1
      }));
      data = updated;
    }
    tagsField.onChange({ target: { value: data, type: "change", name: formFieldUid } })
  }

  return <div ref={boundaryRef} className='asset-details-v2-fields-container__tags-container' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-wrapper`}>
    <div className='asset-details-v2-fields-container__tag-container__item' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-tag-container-item`}>
      <Pills items={tagsField.value} onChange={handleChange} status='default' variant='aiChip' shouldHaveBorder={true} isSortable={true} isEditable={!isReadOnly} highlightAiSuggested={true} maxContainerWidth={420} maxContainerHeight={300} isResizeableContainer={true} isDisabled={isReadOnly} isError={!!tagsMeta.error} minContainerHeight={100} testId={`cs-asset-details-field-${field?.formFieldUid}-pills`} placeholder='-' />
      {getFieldValidationErrorMessageDOM(tagsMeta, undefined, undefined, `cs-asset-details-field-${field?.formFieldUid}-validation-message`)}
      {(!isReadOnly && (field?.enableAiSuggestion || field?.aiUnavailable)) && <SuggestWithAi field={field} AiSuggestionComponent={field?.AiSuggestionComponent} updateValue={tagsField.onChange} boundaryRef={boundaryRef} unavailable={field?.aiUnavailable} unavailableMessage={field?.aiUnavailableMessage} />}
    </div>
  </div>
}

export default Tag